<template>
  <v-menu left oabsolute offset-x transition="scale-transition" origin="top right" v-model="menuOpen" :close-on-content-click="false">
    <template v-slot:activator="{on}">
      <v-list-item v-on="on"><v-list-item-title>Generate QR code</v-list-item-title></v-list-item>
    </template>
    <v-card flat class="pa-2" width="250">
      <v-container>
        <v-row>
          <v-col align="center">
            <div ref="qr"/>
          </v-col>
        </v-row>
        <v-row v-if="askQuantity">
          <v-col>
            <decimal-number-input v-model="data.quantity" label="Quantity" :precision="quantityPrecision" prefix="" :suffix="quantityUnits" @change="generateQR" hide-details/>
          </v-col>
        </v-row>
        <v-row v-if="askLot">
          <v-col>
            <v-combobox label="Lot" :items="lots" v-model="data.lot" dense outlined @change="generateQR" clearable hide-details/>
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center">
            <v-btn small color="primary" :href="dataURL" download="QR Code.png" :disabled="!dataURL">Download</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import QrCreator from 'qr-creator';

export default {
  name: 'GenerateQrCode',
  props: {
    type: {type:String, required:true},
    id: {type:String, required:true},
    cases: {type:Boolean, required:false, default:false},
    askQuantity: {type:Boolean, required:false, default:false},
    quantityUnits: {type:String, required:false, default:''},
    quantityPrecision: {type:Number, required:false, default:0},
    askLot: {type:Boolean, required:false, default:false},
    lots: {type:Array, required:false, default:() => []},
  },
  data: () => {
    return {
      menuOpen: false,
      data: {},
      dataURL: null
    }
  },
  created() {
    this.data = {type:this.type, id:this.id, cases:this.cases, quantity:1, lot:this.askLot?'':null};
  },
  watch: {
    menuOpen() {
      if (this.menuOpen)
        this.generateQR();
    }
  },
  methods: {
    generateQR() {
      this.$nextTick(() => {
        const qrDiv = this.$refs.qr;
        let child = qrDiv.lastElementChild;
        while (child) {
          qrDiv.removeChild(child);
          child = qrDiv.lastElementChild;
        }
        QrCreator.render({
          text: JSON.stringify(this.data),
          radius: 0, // 0.0 to 0.5
          ecLevel: 'M', // L, M, Q, H
          background: '#fff',
          size: 200 // in pixels
        }, this.$refs.qr);
var tmp_canvas = this.$refs.qr.lastElementChild;
this.dataURL = tmp_canvas.toDataURL("image/png");
      });
    }
  }
}
</script>

/*
item.sites -> lot if inBondBottles > 0
*/